import RootState from 'ducks/RootState';
import { SubscriptionActionType } from './types';

export const getIsFetchingSubscriptions = (state: RootState) => state.subscriptions.isFetching;

export const getSubscriptionDetails = (state: RootState) => state.subscriptions.subscriptionDetails;

export const getTotalSubscriptions = (state: RootState) =>
  state.subscriptions.allActiveSubscriptions[0]?.subscriptions_grouped_by[0]?.total_subscriptions ?? 0;

export const getCancelledSubscriptionsGroupedBy = (state: RootState) =>
  state.subscriptions.cancelledSubscriptions[0]?.subscriptions_grouped_by;

export const getAnalyticsSubscriptionsDetails = (state: RootState) =>
  state.subscriptions.allActiveSubscriptions[0]?.subscriptions_grouped_by[0]?.total_subscriptions_per_state ?? [];

export const getNewSubscriptions = (state: RootState) =>
  state.reports?.reportInformation?.numberOfCreatedSubscriptions.total ?? 0;

// export const getTotalCancelledSubscriptions = (state: RootState) =>
//   state.subscriptions.allActiveSubscriptions[0]?.subscriptions_grouped_by[0]?.total_subscriptions_per_state
//     ?.filter((item) => item.action_type === SubscriptionActionType.CANCELLED)
//     .reduce((acc, item) => acc + item.total_subscriptions, 0);

export const getGroupedActiveSubscriptions = (state: RootState) =>
  state.subscriptions.groupedActiveSubscriptions[0]?.subscriptions_grouped_by;

// export const getAllActiveSubscriptions = (state: RootState) =>
//   state.subscriptions.allActiveSubscriptions[0]?.subscriptions_grouped_by[0]?.total_subscriptions_per_state?.filter(
//     (subscription: { action_type: string }) =>
//       subscription.action_type === SubscriptionActionType.RECURRENT ||
//       subscription.action_type === SubscriptionActionType.FREE_TRIAL
//   );

export interface StatsPerCountryChartData {
  [x: string]: any;
  name: string;
  code: string;
  total: number;
  lat: number;
  lon: number;
}

export const getTop5CountriesSubsChartData = (state: RootState): StatsPerCountryChartData[] =>
  state.subscriptions.allCountriesWithSubscriptions
    ?.sort((a, b) => b.total_subscriptions - a.total_subscriptions)
    .slice(0, 5)
    .map((m) => ({
      name: m.geoData?.name || 'N/A',
      code: m.geoData?.code || 'N/A',
      total: m.total_subscriptions || 0,
      lat: m.geoData?.coordinates?.lat || 0,
      lon: m.geoData?.coordinates?.lng || 0,
    }));
